export default __webpack_public_path__ + "static/media/desert.6dfcc44d.png";